var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3492 12.11C17.3492 15.0917 15.5917 16.8492 12.61 16.8492H6.125C3.13583 16.8492 1.375 15.0917 1.375 12.11V5.61C1.375 2.6325 2.47 0.875 5.4525 0.875H7.11917C7.7175 0.875833 8.28083 1.15667 8.63917 1.63583L9.4 2.6475C9.76 3.12583 10.3233 3.4075 10.9217 3.40833H13.28C16.2692 3.40833 17.3725 4.93 17.3725 7.9725L17.3492 12.11Z",
    stroke: "#3E7EEE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73438 11.0534H13.0135",
    stroke: "#3E7EEE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.844c81da4d179c537f54cf8ef98b14e3.svg";
export { ForwardRef as ReactComponent };